import React, { useEffect, useState } from 'react';
import TabList from '@mui/lab/TabList';
import { Box, Tab, Badge } from '@mui/material';
import PropTypes from 'prop-types';
import io from 'socket.io-client';

import Iconify from '../../components/iconify';
import SERVER_API_URL from '../../config';
import axiosInstance from '../../api';

export default function Navbar({ user, unReadChats, manageTarget, setValue, targetType }) {
  const [socket, setSocket] = useState(null);
  const [newPublicChat, setNewPublicChat] = useState(unReadChats?.publicChats?.length || 0);
  const [newDistrictChat, setNewDistrictChat] = useState(unReadChats?.districtChats?.length || 0);
  const [newChurchChat, setNewChurchChat] = useState(unReadChats?.churchChats?.length || 0);
  const [newRoleChat, setNewRoleChat] = useState(unReadChats?.roleChats?.length || 0);
  const [newCategoryChat, setNewCategoryChat] = useState(unReadChats?.categoryChats?.length || 0);
  const [newPersonalChat, setNewPersonalChat] = useState(unReadChats?.personalChats?.length || 0);

  useEffect(() => {
    const readUnreadChats = async () => {
      try {
        const response = await axiosInstance.post(`${SERVER_API_URL}/chat/getUnreadChats/${user && user.id}`);
        if (response.status === 200) {
          const unreadMessage = response.data;
          setNewPublicChat(unreadMessage.publicChats?.length)
          setNewDistrictChat(unreadMessage.districtChats?.length)
          setNewChurchChat(unreadMessage.churchChats?.length)
          setNewRoleChat(unreadMessage.roleChats?.length)
          setNewCategoryChat(unreadMessage.categoryChats?.length)
          setNewPersonalChat(unreadMessage.personalChats?.length)
        }
      } catch (err) {
        // console.log(err)
      }
    }
    readUnreadChats();
  }, [user]);

  const canReadDistrictChat = user?.role?.permissions?.allDistrictChat?.read;
  const canReadChurchChat = user?.role?.permissions?.allChurchChat?.read;
  const canReadRoleChat = user?.role?.permissions?.allRoleChat?.read;
  const canReadCategoryChat = user?.role?.permissions?.allCategoryChat?.read;
  const canReadOwnDistrictChat = user?.role?.permissions?.ownDistrictChat?.read;
  const canReadOwnChurchChat = user?.role?.permissions?.ownChurchChat?.read;
  const canReadOwnRoleChat = user?.role?.permissions?.ownRoleChat?.read;
  const canReadOwnCategoryChat = user?.role?.permissions?.ownCategoryChat?.read;

  useEffect(() => {
    const newSocket = io(`${SERVER_API_URL}`, { transports: ['websocket'] });
    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.on('onMessage', (newMessage) => {
        if (targetType !== 'public' && newMessage.target.public && newMessage.sender.id !== user.id) {
          setNewPublicChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'district' &&
          canReadDistrictChat &&
          newMessage.target.districtId &&
          newMessage.sender.id !== user.id
        ) {
          setNewDistrictChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'church' &&
          canReadChurchChat &&
          newMessage.target.churchId &&
          newMessage.sender.id !== user.id
        ) {
          setNewChurchChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'role' &&
          canReadRoleChat &&
          newMessage.target.roleId &&
          newMessage.sender.id !== user.id
        ) {
          setNewRoleChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'category' &&
          canReadCategoryChat &&
          newMessage.target.categoryId &&
          newMessage.sender.id !== user.id
        ) {
          setNewCategoryChat((newChat) => newChat + 1);
        }
        else if (
          targetType !== 'personal' &&
          newMessage.target.userId === user.id &&
          newMessage.sender.id !== user.id
        ) {
          setNewPersonalChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'district' &&
          canReadOwnDistrictChat &&
          newMessage.target.districtId === user.church.district.id &&
          newMessage.sender.id !== user.id
        ) {
          setNewDistrictChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'church' &&
          canReadOwnChurchChat &&
          newMessage.target.churchId === user.church.id &&
          newMessage.sender.id !== user.id
        ) {
          setNewChurchChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'role' &&
          canReadOwnRoleChat &&
          newMessage.target.roleId === user.role.id &&
          newMessage.sender.id !== user.id
        ) {
          setNewRoleChat((newChat) => newChat + 1);
        } else if (
          targetType !== 'category' &&
          canReadOwnCategoryChat &&
          newMessage.target.categoryId === user.category.id &&
          newMessage.sender.id !== user.id
        ) {
          setNewCategoryChat((newChat) => newChat + 1);
        }
      });
    }

    return () => {
      if (socket) {
        socket.off('onMessage');
      }
    };
  }, [
    socket,
    user,
    targetType,
    canReadDistrictChat,
    canReadChurchChat,
    canReadRoleChat,
    canReadCategoryChat,
    canReadOwnDistrictChat,
    canReadOwnChurchChat,
    canReadOwnRoleChat,
    canReadOwnCategoryChat,
  ]);

  return (
    <TabList onChange={(e, newValue) => setValue(newValue)} variant="scrollable" scrollButtons allowScrollButtonsMobile>
      <Tab
        label={
          <Box>
            <Badge badgeContent={newPublicChat} color="primary">
              <Iconify icon="fluent:people-team-16-filled" sx={{ mr: 0.5 }} />
              የህዝብ
            </Badge>
          </Box>
        }
        value="public"
        onClick={() => {
          manageTarget('public');
          setNewPublicChat(0);
        }}
      />
      {user && user.role.permissions.personalChat.read && (
        <Tab
          label={
            <Box>
              <Badge badgeContent={newPersonalChat} color="primary">
                <Iconify icon="fluent:person-24-filled" sx={{ mr: 0.5 }} />
                ግላዊ
              </Badge>
            </Box>
          }
          value="personal"
          onClick={() => {
            manageTarget('personal');
            setNewPersonalChat(0);
          }}
        />
      )}
      {user && user.role.permissions.ownDistrictChat.read && (
        <Tab
          label={
            <Box>
              <Badge badgeContent={newDistrictChat} color="primary">
                <Iconify icon="fa-solid:map-marked-alt" sx={{ mr: 0.5 }} />
                ወረዳ
              </Badge>
            </Box>
          }
          value="district"
          onClick={() => {
            manageTarget('district');
            setNewDistrictChat(0);
          }}
        />
      )}
      {user && user.role.permissions.ownChurchChat.read && (
        <Tab
          label={
            <Box>
              <Badge badgeContent={newChurchChat} color="primary">
                <Iconify icon="noto:church" sx={{ mr: 0.5 }} />
                ቤተ ክርስቲያን
              </Badge>
            </Box>
          }
          value="church"
          onClick={() => {
            manageTarget('church');
            setNewChurchChat(0);
          }}
        />
      )}
      {user && user.role.permissions.ownCategoryChat.read && (
        <Tab
          label={
            <Box>
              <Badge badgeContent={newCategoryChat} color="primary">
                <Iconify icon="ic:twotone-family-restroom" sx={{ mr: 0.5 }} />
                ምድብ
              </Badge>
            </Box>
          }
          value="category"
          onClick={() => {
            manageTarget('category');
            setNewCategoryChat(0);
          }}
        />
      )}
      {user && user.role.permissions.ownRoleChat.read && (
        <Tab
          label={
            <Box>
              <Badge badgeContent={newRoleChat} color="primary">
                <Iconify icon="carbon:badge" sx={{ mr: 0.5 }} />
                ሚና
              </Badge>
            </Box>
          }
          value="role"
          onClick={() => {
            manageTarget('role');
            setNewRoleChat(0);
          }}
        />
      )}
    </TabList>
  );
}

Navbar.propTypes = {
  user: PropTypes.object.isRequired,
  unReadChats: PropTypes.shape({
    publicChats: PropTypes.array.isRequired,
    personalChats: PropTypes.array.isRequired,
    districtChats: PropTypes.array.isRequired,
    churchChats: PropTypes.array.isRequired,
    categoryChats: PropTypes.array.isRequired,
    roleChats: PropTypes.array.isRequired,
  }).isRequired,
  manageTarget: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  targetType: PropTypes.string.isRequired,
};
